const clubEvent = state => state.clubEvent;

const clubListEvent = state => state.clubListEvent;

const clubEvents = state => state.clubEvents;

const clubListEvents = state => state.clubListEvents;

const clubEventLoading = state => state.clubEventLoading;

const clubEventsLoading = state => state.clubEventsLoading;

const clubEventsMeta = state => state.meta;

const clubEventsLimited = state => state.clubEventsLimited;
const clubEventsLimitedV1 = state => state.clubEventsLimitedV1;

const currentPage = state => state.currentPage;

const messagePageLoading = state => state.messagePageLoading;

export default {
  clubEvent,
  clubListEvent,
  clubEvents,
  clubListEvents,
  clubEventsMeta,
  clubEventLoading,
  clubEventsLoading,
  clubEventsLimited,
  currentPage,
  clubEventsLimitedV1,
  messagePageLoading
};
